import { render, staticRenderFns } from "./EditLicenceSidebar.vue?vue&type=template&id=48186d63"
import script from "./EditLicenceSidebar.vue?vue&type=script&lang=js"
export * from "./EditLicenceSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports